import React, { Fragment } from 'react'
import {
    HomeBannerAssetHome,
    DocumentationAssetHome,
    DeveloperConsoleAssetHome,
    EdgeEngineAssetHome
} from '../../assets/index'
import { DEVELOPER_MIMIK_URL } from '../../constant/path'


const HomePage = () => {
    // const isMobile = window.matchMedia("(max-width:394px)").matches;
    return (
        <Fragment>
            <div className='home_wrapper'>
                <div className='ai_banner'>
                    <div className='ai_link'>
                        <a href='mailto:ai@mimik.com'>ai@mimik.com</a>
                    </div>
                    <div className='ai_buttons'>
                        <a className='ai_button_wrapper' href='https://github.com/mimik-mimOE-ai/mimOE-ai-developer-guide' target='_blank' rel='noopener noreferrer' >
                            <div className='ai_button'>Download</div>
                        </a>
                        <a className='ai_button_wrapper' href='https://www.mimik.com/our-events/live-demo-ai-agents-in-action-gtc-booth-3117' target='_blank' rel='noopener noreferrer' >
                            <div className='ai_button'>Event page</div>
                        </a>
                    </div>
                </div>
                <div className='home_banner'>
                    <div className='home_banner_copy_box'>
                        <h1 className='home_banner_copy_box'>develop with confidence</h1>
                        <p className='home_banner_copy_box'>leverage our advanced edgeCloud native architecture</p>
                        <a className='home_banner_copy_box button' href='./edgeengine-and-microservices/overview'>start your journey now</a>
                    </div>
                    <div className='home_banner_asset'>
                        <img src={HomeBannerAssetHome} alt='' />
                    </div>
                </div>
                <div className='home_cards'>
                    <div className='home_card1'>
                        <div className='home_card1_copy_box'>
                            <h2 className='home_card1_copy_box'>resources &amp; documentation</h2>
                            <p className='home_card1_copy_box'> access in-depth resources and guides</p>
                            <a target='_blank' rel='noopener noreferrer' className='home_card1_copy_box button' href='https://devdocs.mimik.com/'>learn more</a>
                        </div>
                        <div className='home_card1_asset'>
                            <img src={DocumentationAssetHome} alt='' />
                        </div>
                    </div>
                    <div className='home_card2'>
                        <div className='home_card2_copy_box'>
                            <h2 className='home_card2_copy_box'>developer console</h2>
                            <p className='home_card2_copy_box'>sign up to access our feature-rich developer tools and manage your projects seamlessly</p>
                            <a target='_blank' rel='noopener noreferrer' className='home_card2_copy_box button' href={DEVELOPER_MIMIK_URL + 'login'}>create an account</a>
                        </div>
                        <div className='home_card2_asset'>
                            <img src={DeveloperConsoleAssetHome} alt='' />
                        </div>
                    </div>
                    <div className='home_card3'>
                        <div className='home_card3_copy_box'>
                            <h2 className='home_card3_copy_box'>download edgeEngine</h2>
                            <p className='home_card3_copy_box'>install edgeEngine and start building applications for a variety of platforms</p>
                            <a className='home_card3_copy_box button' href='./downloads'>download edgeEngine</a>
                        </div>
                        <div className='home_card3_asset'>
                            <img src={EdgeEngineAssetHome} alt='' />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default HomePage